import { CountryCode, Currency } from '@/enums';
import { getCountryCode } from './CountryCodeHelper';

export const addThousandSeparatorsWithPrecision = (
  param: number | undefined,
) => {
  if (param && !isNaN(param)) {
    return param.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else return '0.00';
};

export const addThousandSeparator = (param: number | undefined) => {
  if (param && !isNaN(param)) {
    return param.toLocaleString();
  } else return '0';
};

export const getCurrency = () => {
  const currency = {
    [CountryCode.Malaysia]: Currency.RM,
    [CountryCode.Philippines]: Currency.PHP,
  };

  return currency[getCountryCode()];
};

export const getCurrencySymbol = () => {
  const currency = {
    [CountryCode.Malaysia]: 'MYR',
    [CountryCode.Philippines]: 'PHP',
  };

  return currency[getCountryCode()];
};

export const formatAmountWithPrecision = (param: number | undefined) => {
  return [getCurrency(), addThousandSeparatorsWithPrecision(param)].join(' ');
};

export const roundToNearestThousand = (param: number) => {
  return Math.round(param / 1000) * 1000;
};
